export enum PostAuthorType {
  Place = 0,
  User = 1,
  CoffeeIn = 2
}

export enum PostStatus {
  Draft = 0,
  Published = 1,
  Archived = 2
}

export interface Post {
  id: string;
  title: string;
  content: string;
  summary: string;
  images: string[];
  authorType: PostAuthorType;
  authorId?: string;
  authorName?: string;
  authorAvatar?: string;
  cityId?: string;
  cityName?: string;
  status: PostStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePostDto {
  title: string;
  content: string;
  summary: string;
  images: string[];
  cityId?: string;
}

export interface UpdatePostDto {
  id: string;
  title: string;
  content: string;
  summary: string;
  images: string[];
  cityId?: string;
  status: PostStatus;
}

export interface PostListDto {
  posts: Post[];
  nextCursor?: string;
  hasMore: boolean;
  totalCount: number;
}

export interface PostFilter {
  cityId?: string;
  authorType?: PostAuthorType;
  status?: PostStatus;
  pageSize?: number;
  cursor?: string;
}
